module.exports = __webpack_public_path__ + "static/media/Aspen1.0424a028.jpg";